import { render, staticRenderFns } from "./Com.vue?vue&type=template&id=e5cd6522&scoped=true&"
import script from "./Com.vue?vue&type=script&lang=js&"
export * from "./Com.vue?vue&type=script&lang=js&"
import style0 from "./Com.vue?vue&type=style&index=0&id=e5cd6522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd6522",
  null
  
)

export default component.exports